import { render, staticRenderFns } from "./university-campaigns.vue?vue&type=template&id=b3029ee4&scoped=true&"
import script from "./university-campaigns.vue?vue&type=script&lang=js&"
export * from "./university-campaigns.vue?vue&type=script&lang=js&"
import style0 from "./university-campaigns.vue?vue&type=style&index=0&id=b3029ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3029ee4",
  null
  
)

export default component.exports